<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../assets/loader.gif" />
    </vue-element-loading>
    <div class="animated fadeIn">
      <b-row v-if="analytics">
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-wpforms bg-primary p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-primary mb-0 mt-2">{{dashdata.activeReports}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">TOTAL REPORTS</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Reports" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-info mb-0 mt-2">{{dashdata.admins}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">ADMINS</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Admins" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-info mb-0 mt-2">{{dashdata.activeUsers}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">USERS</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Users" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
        <!-- <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-moon-o bg-warning p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-warning mb-0 mt-2">{{analytics.havebeencutcount}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">TREES HAVE BEEN CUT</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Incidents" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col> -->
        
      </b-row>

      
      <b-row v-if="analytics">
        <b-col md="12">
          <b-card header="Last 10 Reports">
            <br />
            <b-table
              :hover="true"
              :striped="true"
              :bordered="false"
              :small="false"
              :fixed="false"
              class="mb-0 table-outline"
              responsive="sm"
              :items="analytics"
              :fields="TableFields"
              head-variant="light"
              @row-clicked="rowClicked"
            >
              <template v-slot:cell(reportid)="data">
              <span v-if="data.item.reportID">{{data.item.reportID}}</span>
            </template>
            <template v-slot:cell(reportdate)="data">
              <span v-if="data.item.added_date">{{formatDate(data.item.added_date)}}</span>
            </template>
           <template v-slot:cell(crime)="data">
              <span
                v-if="data.item.crimeTypeId"
              >{{data.item.crimeTypeId.cname}}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:cell(country)="data">
              <span
                v-if="data.item.country"
              >{{data.item.country}}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:cell(nation)="data">
              <span
                v-if="data.item.nationality"
              >{{data.item.nationality}}</span>
              <span v-else>-</span>
            </template>
            </b-table>
            <template slot="footer">
              <router-link to="/Reports">
                <b-button size="sm">View More</b-button>
              </router-link>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import MainChartExample from "./MainChartExample";

export default {
  components: {
    MainChartExample,
  },
  data() {
    return {
      chartName: "Last Year",
      chartTypes: [
        { name: "Last Year", value: 12 },
        { name: "Last 6 Months", value: 6 },
        { name: "Last 4 Months", value: 4 },
        { name: "Last 3 Months", value: 3 },
      ],
      chartType: 12,
      TableFields: [
        { key: "reportid", label: "Id", sortable: false },
        { key: "reportdate", label: "Date", sortable: false },
         { key: "crime", label: "Type of crime", sortable: false },
        { key: "country", label: "Country", sortable: false },
        { key: "nation", label: "Nationality", sortable: false },
       
      ],
      dashdata:null,
      analytics: null,
      appLoading: false,
      ServerError: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/dashboard/data",
        method: "POST",
        headers: {
          "token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.analytics = response.data.latestActiveReports;
          this.dashdata = response.data.data;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },

    rowClicked(item) {
      this.$router.push("/Reports/" + item._id);
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style>
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
